<template>
	<search-list ref="sl" :where="where" api-path="/mmpCamp/list" notSearchAll :searchKeys="searchKeys" :handleResponse="handleResponse">
		<mm-lc title="Offer Month" class="gim-select">
			<singleMonthPicker v-model="where.offer_month" />
		</mm-lc>
		<mm-lc title="Adv">
			<mm-adv-select no_paused v-model="where.adv_id" multiple />
		</mm-lc>
		<mm-lc title="Tracker">
			<mm-dict-select v-model="where.tracker_id" dictType="tracker"></mm-dict-select>
		</mm-lc>
		<mm-lc title="Channel">
			<mm-channel-select no_paused v-model="where.channel_id" multiple />
		</mm-lc>
		<mm-lc title="Manual Status">
			<mm-offer-status v-model="where.manual_status" multiple />
		</mm-lc>
		<mm-lc title="Platform">
			<mm-offer-platform v-model="where.platform" multiple />
		</mm-lc>
		<template slot="customSearch">
			<mm-lc title="Pid">
				<mm-multi-input v-model.trim="where.pid"/>
			</mm-lc>
			<mm-lc title="Af Prt">
				<mm-multi-input v-model.trim="where.af_prt"/>
			</mm-lc>
		</template>

		<el-dropdown size="mini" trigger="click" slot="statusAction">
			<el-button size="small" type="primary">
				<i class="el-icon-edit"></i>Batch Op
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item @click.native="batchEditInfo()">Edit Info</el-dropdown-item>
				<el-dropdown-item class="status-active" @click.native="batchOp(switchStatus,'active')">Switch to Active</el-dropdown-item>
				<el-dropdown-item class="status-paused" @click.native="batchOp(switchStatus,'paused')">Switch to Paused</el-dropdown-item>
				<el-dropdown-item class="status-pending" @click.native="batchOp(switchStatus,'pending')">Switch to Pending</el-dropdown-item>
				<!-- <el-dropdown-item class="status-paused" @click.native="batchOp(deleteAll,'')">Switch to Delete</el-dropdown-item> -->
				<el-dropdown-item class="status-pending" @click.native="batchEditRemark()">Remark</el-dropdown-item>
				<el-dropdown-item class="status-pending" @click.native="batchSendTipsMail()">Send Mail</el-dropdown-item>
				<el-dropdown-item class="status-pending" @click.native="openCopyToAnotherMonthDialog">Switch to Another Month</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>

		<mm-table slot="dataTable" slot-scope="res" :res="res" @selection-change="selectionChange">
			<template slot-scope="etc">
			<el-table-column type="selection" fixed />
			<el-table-column label="Offer Month" prop="offer_month" min-width="150" fixed />
			<el-table-column label="Offer Id" prop="offer_id" min-width="150" :renderHeader="renderHeaderCopyOfferId" fixed>
				<mm-get-detail slot-scope="sp" row_type="mmp_offer" :row_id="sp.row.offer_id+','+sp.row.offer_month" :row_name="sp.row.offer_id" />
			</el-table-column>
			<el-table-column label="Offer Name" prop="offer_name" min-width="150" fixed :renderHeader="etc.renderHeaderCopyNew('\r')"/>
			<el-table-column label="Prt" prop="prt" width="120" fixed>
				<span slot-scope="sp">{{ sp.row.offer && sp.row.offer.af_prt }}</span>
			</el-table-column>
			<el-table-column prop="pid" label="Pid" width="120" fixed  :renderHeader="renderHeaderCopy"></el-table-column>
			<el-table-column label="Channel Id" width="120" prop="channel_id" fixed></el-table-column>
			<el-table-column label="Channel" width="120" prop="channel_name" fixed>
				<mm-get-detail slot-scope="sp" :row_id="sp.row.channel_id" :row_name="sp.row.channel_name" :row_type="'channel'"/>
			</el-table-column>
			<el-table-column label="Adv Id" prop="adv_id" width="120"></el-table-column>
			<el-table-column label="Adv" prop="adv_name" width="120">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" row_type="adv" />
			</el-table-column>
			<el-table-column width="98" label="Price" prop="offer_price"></el-table-column>
			<el-table-column label="Cap" prop="cap_info" min-width="100" />
			<!-- <el-table-column width="120" label="Event Count" prop="event_count"></el-table-column> -->
			<el-table-column label="Time" prop="update_at" min-width="140">
				<span slot-scope="sp">{{timeFormat(sp.row.update_at)}}</span>
			</el-table-column>
			<el-table-column label="Remark" prop="remark" min-width="140">
				<template slot-scope="sp">
					<div v-if="!sp.row.remark || sp.row.remark.length <= 20">{{ sp.row.remark }}</div>
					<el-popover
						v-else
						placement="top-start"
						width="200"
						trigger="click"
					>
						<div v-html="sp.row.remark.replace(/\n/g, '<br/>')">
						</div>
						<el-button slot="reference" type="text">{{ sp.row.remark.substring(0, 20) + '...' }}</el-button>
					</el-popover>
				</template>
			</el-table-column>
			<el-table-column label="Manual Status" prop="manual_status" fixed="right" width="120">
				<span slot-scope="sp" :class="'status-'+sp.row.manual_status">{{sp.row.manual_status&&sp.row.manual_status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Actions" fixed="right">
				<el-button slot-scope="sp" @click.native="edit(sp.row)" >Edit</el-button>
			</el-table-column>
		</template>
		</mm-table>
		<el-dialog :visible.sync="showEditInfo">
			<span slot="title">Edit Info</span>
			<el-form ref="form" :model="info" label-width="100px">
				<!-- <el-form-item label="Pid" required>
					<div class="percent-input">
						<el-input v-model.trim="info.pid"/>
					</div>
				</el-form-item> -->
				<el-form-item label="Offer Price" prop="offer_price" required >
					<div class="percent-input" style="display:flex;">
						<el-input type="number" @mousewheel.native.prevent v-model="info.offer_price"/>
						<el-checkbox v-model="info.is_edit_offer_price" style="margin-left:10px;"></el-checkbox>
					</div>
				</el-form-item>
				<el-form-item label="Cap" >
					<div class="percent-input" style="display:flex;">
						<el-input v-model="info.cap_info"/>
						<el-checkbox v-model="info.is_edit_cap_info" style="margin-left:10px;"></el-checkbox>
					</div>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click='updateInfo()'>Save</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="showEditRemark">
			<span slot="title">Edit Remark</span>
			<el-form ref="remarkForm" :model="remarkInfo" label-width="100px">
				<el-form-item label="Remark" required style="width:100%;">
					<el-input type="textarea" rows="6" v-model="remarkInfo.remark" />
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="updateInfo('remark')">Save</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog :visible.sync="setMailTypeVisible">
			<span slot="title">Mail Type</span>
			<el-form ref="remarkForm" :model="info" label-width="100px">
				<el-form-item label="Mail Type" required style="width:100%;">
					  <el-radio-group v-model="mailType">
							<el-radio label="1" style="margin-left:30px;">Pause Notification</el-radio>
							<el-radio label="2">Cap Update</el-radio>
							<el-radio label="3">Payout Update</el-radio>
							<el-radio label="4">Resume Notification</el-radio>
							<el-radio label="5">Budget Update</el-radio>
							<el-radio label="6">Link Update</el-radio>
							<el-radio label="7">Payable event Update</el-radio>
						</el-radio-group>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="setMail">Show Mail</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		
    <el-dialog
      title="Send Email"
      :visible.sync="sendMailVisible"
      width="80%"
      append-to-body
    >
      <div class="send-mail-dialog-container">
        <el-form
          :model="mailInfo"
          label-width="200px"
        >
          <el-form-item label="Title">
            <el-input v-model="mailInfo.title" style="width:700px;"></el-input>
          </el-form-item>
          <el-form-item label="Remark" style="height:200px;">
            <mm-editor :content.sync="mailInfo.remark" :contentHeight="'100px'" style="width:700px;margin-bottom:20px;"></mm-editor>
          </el-form-item>
          <el-form-item label="Content" style="height:360px;width:900px;">
						<div style="height:320px;overflow:hidden;overflow-y:auto;line-height:20px;margin-top:10px;padding-right:20px;">
							<div v-html="mailInfo.msg"></div>
						</div>
          </el-form-item>
        </el-form>
        <div style="text-align: right">
          <el-button type="primary" @click="sendMailSubmit" :disabled="sendMailLoading">Submit</el-button>
        </div>
      </div>
    </el-dialog>
		<el-dialog :visible.sync="copyToOtherMonthVisible">
			<span slot="title">Copy To Another Month</span>
			<el-form label-width="200px" class="edit-timezone" ref="copyForm"  :model="copyBody">
				<el-form-item label="Another Month" prop="month" required>
					<el-date-picker v-model="copyBody.month" type="month" value-format="yyyy-MM"></el-date-picker>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="copySubmit">Save</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</search-list>
</template>

<script>
import singleMonthPicker from '../components/common/singleMonthPicker.vue';
export default {
	components: {
		singleMonthPicker,
	},
	data() {
		const searchKeys = {
			offer_id: { label: "Offer Id" },
			adv_offer_id: { label: "Adv Offer Id" },
			package_id: { label: "Package Id", fuzzy: true },
		};
		const offer_month = this.$utils.date_format((new Date()),'YYYY-MM');
		return {
			where: {
				offer_month,
			},
			searchKeys,
			selected: [],
			selectedList: [],
			showEditInfo: false,
			showEditRemark: false,
			info:{
				pid: '',
				cap_info: '',
				offer_price: 0,
			},
			remarkInfo: {
				remark: '',
			},
			setMailTypeVisible: false,
			sendMailVisible: false,
			mailType: '',
			mailInfo: {
				title: '',
				msg: '',
				channel_id: '',
				remark: '',
			},
			sendMailLoading: false,
			copyBody: {
				month: '',
			},
			copyToOtherMonthVisible: false,
		};
	},
	methods: {
		openCopyToAnotherMonthDialog() {
			if (this.selected.length === 0) {
				this.$message({ message: "no selection!", type: "warning" });
			} else {
				this.copyToOtherMonthVisible = true;
			}
		},
		async copySubmit() {
			const camp_info = this.selectedList.map((row) => {
				return {
					_id: row._id,
				}
			})
			await this.$post("/mmpCamp/switchToCurrentMonth", {
				camp_info,
				month: this.copyBody.month,
			});
			this.copyToOtherMonthVisible = false;
		},
		handleResponse(body) {
			body.rows && body.rows.forEach((row) => {
				if (row.offer && row.offer.af_prt) {
					row.prt = row.offer.af_prt;
				}
			})
		},
		timeFormat(date) {
			date = new Date(date);
			return this.$utils.date_format(date, "YYYY-MM-DD hh:mm:ss");
		},
		selectionChange(v) {
			this.selected = v.map(v => {
        return v._id;
      });
			this.selectedList = v;
		},
		edit(row) {
			window.open(`/mmpCampEdit?id=${row._id}`);
		},
		batchEditInfo() {
			this.info = {
				// pid: '',
				cap_info: '',
				offer_price: 0,
				is_edit_cap_info: true,
				is_edit_offer_price: true,
			}
			this.showEditInfo = true;
		},
		batchEditRemark() {
			this.remarkInfo = {
				remark: '',
			}
			this.showEditRemark = true;
		},
		async updateInfo(type = '') {
			this.showEditInfo = false;
			this.info._ids = this.selected;
			const info = {};
			if (this.info.is_edit_offer_price) {
				info.offer_price = this.info.offer_price;
			}
			if (this.info.is_edit_cap_info) {
				info.cap_info = this.info.cap_info;
			}
			const body = type == 'remark' ? this.remarkInfo : info;
			body._ids = this.selected;
			await this.$post("/mmpCamp/batchEdit", body);
			this.$refs.sl.refresh();
		},
		async batchOp(fn, value) {
			if (this.selected.length === 0) {
				this.$message({ message: "no selection!", type: "warning" });
			} else {
				await fn(value);
				await this.$refs.sl.refresh();
				this.$refs.dataTable.$el.$refs.mm_table.clearSelection();
				this.selected = [];
			}
		},
		async deleteAll() {
			await this.$confirm('Delete All?', 'Tips', {
				confirmButtonText: 'Yes',
				cancelButtonText: 'No',
				type: 'warning'
			}).then(async () => {
				await this.$post("/mmpCamp/delete", {ids:this.selected});
			})
		},
		async switchStatus(status) {
			await this.$post("/mmpCamp/switchStatus", {
				ids: this.selected,
				status
			});
		},
		renderHeaderCopyOfferId(h, { column }) {
			const _this = this;
			return h('div',[
				h('span', column.label),
				h('el-button', {
					props: {
						type: 'text',
					},
					on: {
						click: async function() {
							console.log('_this.$refs.sl',_this.$refs.sl)
							const arr = _this.$refs.sl.rows.filter((row) => {
								if (_this.selected.length && !_this.selected.includes(row._id)) {
									return false;
								}
								return true;
							}).map((row) => {
								return row[column.property];
							})
							let text = arr.join(`,`);
							
							await _this.$copyText((text));
							_this.$message({
								type:'success',
								message:`Copied ${column.label} success`,
							})
						},
					}
				}, [
					h('i', {
						class: "el-icon-edit",
						style: "margin-left:10px"
					})
				])
			]);
		},
		renderHeaderCopy(h, { column }) {
			const _this = this;
			return h('div',[
				h('span', 'Pid'),
				h('el-button', {
					props: {
						type: 'text',
					},
					on: {
						click: async function() {
							const arr = _this.$refs.sl.rows.filter((row) => {
								if (_this.selected.length && !_this.selected.includes(row._id)) {
									return false;
								}
								return true;
							}).map((row) => {
								return row[column.property];
							})
							let text = arr.join(`\r`);
							
							await _this.$copyText((text));
							_this.$message({
								type:'success',
								message:`Copied ${column.label} success`,
							})
						},
					}
				}, [
					h('i', {
						class: "el-icon-edit",
						style: "margin-left:10px"
					})
				])
			]);
		},
		batchSendTipsMail() {
			if (this.selectedList.length === 0) {
				this.$message({ message: "no selection!", type: "warning" });
				return;
			}
			let hasDiffChannel = false;
			let hasDiffDate = false;
			let hasDiffOffer = false;
			const channel_id = this.selectedList[0].channel_id;
			const date = this.selectedList[0].offer_month;
			const offer_id = this.selectedList[0].offer_id;
			this.selectedList.forEach((row) => {
				if (row.channel_id != channel_id) {
					hasDiffChannel = true;
				}
				if (row.offer_month != date) {
					hasDiffDate = true;
				}
				if (row.offer_id != offer_id) {
					hasDiffOffer = true;
				}
			})
			if (hasDiffChannel) {
				this.$message({ message: 'The Channel must be the same', type: 'warning' });
				return;
			} else if (hasDiffDate) {
				this.$message({ message: 'The Offer Month must be this same', type: 'warning' });
				return;
			} else if (hasDiffOffer) {
				this.$message({ message: 'The Offer Id must be this same', type: 'warning' });
				return;
			}
			this.setMailTypeVisible = true;
		},
		setMail() {
			this.mailInfo.channel_id = this.selectedList[0].channel_id;
			const offerInfo = this.selectedList[0];
			const date = this.$utils.date_format(new Date(), "YYYY-MM-DD");
			if (this.mailType == '1') {
				this.mailInfo.title = `Pause Notification: ${offerInfo.offer_name}/${offerInfo.channel_name}/${date}`;
				this.mailInfo.msg = ``;
				this.selectedList.forEach((offer) => {
				this.mailInfo.msg += `<div style="color:red;font-weight:700;">Pause Notification:</div>
															<div>Offer ID: ${offer.offer_id}</div>
															<div>Offer Name: ${offer.offer_name}</div>
															<div>Package Id:	${offer.package_id && offer.package_id.replace('\n', '')}</div>
															<div>Preview Url: ${offer.preview_url}</div>
															<div>AF prt: <span style="color:red;font-weight:700;">${offer.af_prt}</span></div>
															<div>Pid: <span style="color:red;font-weight:700;">${offer.pid}</span></div>
															<br/>`
				})
				this.mailInfo.msg += '<p>Please pause this campaign on your end. We will keep you updated with any further information regarding its status. </p>'
			} else if (this.mailType == '2') {
				this.mailInfo.title = `Cap update: ${offerInfo.offer_name}/${offerInfo.channel_name}/${date}`;
				this.mailInfo.msg = ``;
				this.selectedList.forEach((offer) => {
				this.mailInfo.msg += `<div>Cap update:</div>
															<div>Offer ID: ${offer.offer_id}</div>
															<div>Offer Name: ${offer.offer_name}</div>
															<div>Package Id:	${offer.package_id && offer.package_id.replace('\n', '')}</div>
															<div>Preview Url: ${offer.preview_url}</div>
															<div>AF prt: <span style="color:red;font-weight:700;">${offer.af_prt}</span></div>
															<div>Pid: <span style="color:red;font-weight:700;">${offer.pid}</span></div>
															<div>Cap update: <span style="color:red;font-weight:700;">${offer.cap_info}</span></div>
															<br/>`
				})
				this.mailInfo.msg += '<p>Please update the cap for this campaign on your end ASAP. Thanks. </p>'
			} else if (this.mailType == '3') {
				this.mailInfo.title = `New Payout Update: ${offerInfo.offer_name}/${offerInfo.channel_name}/${date}`;
				this.mailInfo.msg = ``;
				this.selectedList.forEach((offer) => {
				this.mailInfo.msg += `<div>New Payout Update:</div>
															<div>Offer ID: ${offer.offer_id}</div>
															<div>Offer Name: ${offer.offer_name}</div>
															<div>Package Id:	${offer.package_id && offer.package_id.replace('\n', '')}</div>
															<div>Preview Url: ${offer.preview_url}</div>
															<div>AF prt: <span style="color:red;font-weight:700;">${offer.af_prt}</span></div>
															<div>Pid: <span style="color:red;font-weight:700;">${offer.pid}</span></div>
															<div>New Payout Update: <span style="color:red;font-weight:700;">$${offer.offer_price}</span></div>
															<br/>
															<br/>`
				})
				this.mailInfo.msg += '<p>Please update the payout for this campaign on your end ASAP. Thanks. </p>'
			} else if (this.mailType == '4') {
				this.mailInfo.title = `Resume Notification: ${offerInfo.offer_name}/${offerInfo.channel_name}/${date}`;
				this.mailInfo.msg = ``;
				this.selectedList.forEach((offer) => {
				this.mailInfo.msg += `<div style="color:green;font-weight:700;">Resume Notification:</div>
															<div>Offer ID: ${offer.offer_id}</div>
															<div>Offer Name: ${offer.offer_name}</div>
															<div>Package Id:	${offer.package_id && offer.package_id.replace('\n', '')}</div>
															<div>Preview Url: ${offer.preview_url}</div>
															<div>AF prt: <span style="color:green;font-weight:700;">${offer.af_prt}</span></div>
															<div>Pid: <span style="color:green;font-weight:700;">${offer.pid}</span></div>
															<div>Cap: <span>${offer.cap_info}</span></div>
															<div>Tracking Link: <span>${offer.tracking_link && offer.tracking_link.replace(/\n/g, '<br/>')}</span></div>
															<br/>
															<br/>`
				})
				this.mailInfo.msg += '<p>Please resume this campaign on your end ASAP. Thanks.</p>'
			} else if (this.mailType == '5') {
				this.mailInfo.title = `Budget Update: ${offerInfo.offer_name}/${offerInfo.channel_name}/${date}`;
				this.mailInfo.msg = ``;
				this.selectedList.forEach((offer) => {
				this.mailInfo.msg += `<div style="color:green;font-weight:700;">Keep Running Notification:</div>
															<div>Offer ID: ${offer.offer_id}</div>
															<div>Offer Name: ${offer.offer_name}</div>
															<div>Package Id:	${offer.package_id && offer.package_id.replace('\n', '')}</div>
															<div>Preview Url: ${offer.preview_url}</div>
															<div>AF prt: <span style="color:green;font-weight:700;">${offer.af_prt}</span></div>
															<div>Pid: <span style="color:green;font-weight:700;">${offer.pid}</span></div>
															<div>Payout: ${offer.offer_price}</div>
															<div>Cap: <span>${offer.cap_info}</span></div>
															<div>Tracking Link: <span>${offer.tracking_link && offer.tracking_link.replace(/\n/g, '<br/>')}</span></div>
															<br/>`
				})
				this.mailInfo.msg += '<p>Please keep running this campaign on your end. Thanks. </p>'
			} else if (this.mailType == '6') {
				this.mailInfo.title = `Tracking link Update: ${offerInfo.offer_name}/${offerInfo.channel_name}/${date}`;
				this.mailInfo.msg = ``;
				this.selectedList.forEach((offer) => {
				this.mailInfo.msg += `<div style="font-weight:700;">Link Update:</div>
															<div>Offer ID: ${offer.offer_id}</div>
															<div>Offer Name: ${offer.offer_name}</div>
															<div>Package Id:	${offer.package_id && offer.package_id.replace('\n', '')}</div>
															<div>Preview Url: ${offer.preview_url}</div>
															<div>AF prt: <span style="color:red;font-weight:700;">${offer.af_prt}</span></div>
															<div>Pid: <span style="color:red;font-weight:700;">${offer.pid}</span></div>
															<div>Tracking Link: <span style="color:red;font-weight:700;">${offer.tracking_link && offer.tracking_link.replace(/\n/g, '<br/>')}</span></div>
															<br/>`
				})
				this.mailInfo.msg += '<p>Please update the tracking link for this campaign on your end ASAP. Thanks. </p>'
			} else if (this.mailType == '7') {
				this.mailInfo.title = `New Payable Event Update: ${offerInfo.offer_name}/${offerInfo.channel_name}/${date}`;
				this.mailInfo.msg = ``;
				this.selectedList.forEach((offer) => {
				this.mailInfo.msg += `<div style="font-weight:700;">New Payable Event Update:</div>
															<div>Offer ID: ${offer.offer_id}</div>
															<div>Offer Name: ${offer.offer_name}</div>
															<div>Package Id:	${offer.package_id && offer.package_id.replace('\n', '')}</div>
															<div>Preview Url: ${offer.preview_url}</div>
															<div>AF prt: <span style="color:red;font-weight:700;">${offer.af_prt}</span></div>
															<div>Pid: <span style="color:red;font-weight:700;">${offer.pid}</span></div>
															<div>New Payable Event Update: <span style="color:red;font-weight:700;">${offer.offer.events.map((event) => {
																return event.event_value;
															}).join(',')}</span></div>
															<br/>`
				})
				this.mailInfo.msg += '<p>Please update the new payable event  for this campaign on your end ASAP. Thanks.</p>'
			}
			this.sendMailVisible = true;
		},
		sendMailSubmit() {
			this.sendMailLoading = true;
			const remark = `<div class="mmp-offer-detail-container">
      <style>.mmp-offer-detail-container p { margin: 0; }</style>
      ${this.mailInfo.remark}
      </div>`;
			this.$post('/mmpOffer/sentDetailMail', { 
				...this.mailInfo,
				msg: remark + this.mailInfo.msg,
			}).then(() => {
				this.$message({
					type:'success',
					message:'Email sending...',
				})
				this.sendMailVisible = false;
				this.setMailTypeVisible = false;
				this.sendMailVisible = false;
			}).finally(() => {
				this.sendMailLoading = false;
			})
			if (this.mailType == '1') {
				this.switchStatus('paused');
			}
		}
	}
};
</script>

<style scoped>
.percent-input {
	width: 130px;
}
.el-form-item {
	width: 500px;
}
</style>


